module.exports = {
  "FormControlsTokens" : {
    "border": {
        "radius": {
            "value": "4px"
        },
        "width": {
            "value": "1px"
        }
    },
    "color": {
        "background": {
            "onlight": {
                "value": "#ffffff"
            },
            "ondark": {
                "value": "#000000"
            }
        },
        "border": {
            "onlight": {
                "value": "#6f7171"
            },
            "ondark": {
                "value": "#a7a7a7"
            },
            "hover": {
                "onlight": {
                    "value": "#000000"
                },
                "ondark": {
                    "value": "#ffffff"
                }
            },
            "readonly": {
                "onlight": {
                    "value": "#d8dada"
                },
                "ondark": {
                    "value": "#333333"
                }
            }
        }
    },
    "space": {
        "inset": {
            "value": "12px"
        }
    }
}
    }


//////////////////
// WEBPACK FOOTER
// ./~/@vds-tokens/form-controls/dist/cjs/tokens.js
// module id = 148
// module chunks = 0